module.exports = __webpack_public_path__ + "img/collaborate_60.807c2b6f.jpg";